export const StockImage = () => (
  <svg
    width="129"
    height="117"
    viewBox="0 0 129 117"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_32357_8664)">
      <path d="M1.03979 83.1977L77.0434 116.001C77.0856 116.017 77.1277 115.99 77.1277 115.943V1.00752C77.1277 0.954823 77.075 0.917936 77.0276 0.939015L1.03979 32.7359V83.2029V83.1977Z" />
      <path d="M127.985 91.2179L77.2175 115.996C77.1754 116.017 77.1279 115.985 77.1279 115.943V1.01271C77.1279 0.960011 77.1859 0.923124 77.2333 0.944203L127.985 24.9578V91.2127V91.2179Z" />
      <path
        d="M65.9457 101.399L73.0913 103.918V10.5402L65.9457 13.096V101.399Z"
        fill="white"
      />
      <path
        d="M53.757 97.1042L59.5377 99.1435V15.3883L53.757 17.4593V97.1042Z"
        fill="white"
      />
      <path
        d="M43.7501 93.5736L48.5191 95.2546V19.3353L43.7501 21.0427V93.5736Z"
        fill="white"
      />
      <path
        d="M35.3768 90.6225L39.0814 91.9293V22.713L35.3768 24.0356V90.6225Z"
        fill="white"
      />
      <path
        d="M28.2784 88.1196L31.6879 89.321V25.3585L28.2784 26.5757V88.1196Z"
        fill="white"
      />
      <path
        d="M22.1763 85.9642L25.1167 87.0023V27.7086L22.1763 28.7625V85.9642Z"
        fill="white"
      />
      <path
        d="M16.8804 84.0988L19.4361 84.9999V29.7427L16.8804 30.6597V84.0988Z"
        fill="white"
      />
      <path
        d="M12.2378 82.46L14.4826 83.2557V31.5134L12.2378 32.3196V82.46Z"
        fill="white"
      />
      <path
        d="M8.13281 81.016L10.1247 81.7169V33.0784L8.13281 33.7898V81.016Z"
        fill="white"
      />
      <path
        d="M4.48108 79.7251L6.25694 80.3522V34.4591L4.48108 35.0967V79.7251Z"
        fill="white"
      />
      <path
        d="M86.7923 101.488L80.453 104.018V10.4401L86.7923 13.0064V101.488Z"
        fill="white"
      />
      <path
        d="M97.6109 97.1726L92.4835 99.2225V15.3092L97.6109 17.3854V97.1726Z"
        fill="white"
      />
      <path
        d="M106.495 93.6314L102.259 95.323V19.2667L106.495 20.9793V93.6314Z"
        fill="white"
      />
      <path
        d="M113.92 90.6699L110.363 92.0874V22.5496L113.92 23.9882V90.6699Z"
        fill="white"
      />
      <path
        d="M117.193 25.311L120.218 26.5336V88.1617L117.193 89.3685V25.311Z"
        fill="white"
      />
      <path
        d="M125.624 86.0064L123.016 87.0445V27.6718L125.624 28.7257V86.0064Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_32357_8664">
        <rect
          width="127.867"
          height="116"
          fill="white"
          transform="translate(0.576172 0.469971)"
        />
      </clipPath>
    </defs>
  </svg>
);
